/**
 * apportionCostCenter模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const apportionCostCenter = {
  //成本中心下拉框
  apportionCostCenterSelect(params) {
    return $http.post(`${global.API_URL}/sme/apportionCostCenter/apportionCostCenterSelect`,params);
  }
}

export default apportionCostCenter;



// WEBPACK FOOTER //
// ./src/api/apportionCostCenter.js